import React from 'react';
import { Shield, Zap, Clock, TrendingUp } from 'lucide-react';
import { benefits } from '../data/mock';

const iconMap = {
  shield: Shield,
  zap: Zap,
  clock: Clock,
  trending: TrendingUp,
};

const BenefitsSection = () => {
  return (
    <section className="bg-[#0a0a0b] py-24 px-6">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-[#1a1a1f] border border-white/10 text-sm text-gray-300 mb-6">
            Why Choose Ruonn
          </div>
          <h2 className="text-4xl md:text-5xl text-white font-normal mb-4">
            Built for <span className="italic font-light">your success.</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            We've helped hundreds of companies build world-class engineering teams.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {benefits.map((benefit) => {
            const Icon = iconMap[benefit.icon];
            return (
              <div
                key={benefit.id}
                className="group p-6 rounded-2xl bg-[#1a1a1f] border border-white/5 hover:border-purple-500/30 transition-all duration-500 hover:scale-[1.02]"
              >
                <div className="w-12 h-12 rounded-xl bg-purple-600/20 flex items-center justify-center mb-4 group-hover:bg-purple-600/30 transition-colors">
                  <Icon className="w-6 h-6 text-purple-400" />
                </div>
                <h3 className="text-white text-lg font-medium mb-2">{benefit.title}</h3>
                <p className="text-gray-400 text-sm leading-relaxed">{benefit.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
